// Predefined Platform abbreviations

const PLATFORM_ABBR = {
  foodpanda: 'FP',
  grab: 'GF',
  deliver_eat: 'DE',
  lolol: 'LO',
  go_eat: 'GE',
  oddle: 'OD',
  whatsapp: 'WA',
  website: 'FV',
  dego: 'DE',
  beep_delivery: 'BD',
  hungry2u: 'HU',
  others: 'OP',
};

export const ORDER_BY = {
  MM: 'MM',
  MPOS: 'mPOS',
  AUTO: 'auto',
  USER: 'user',
};

export default PLATFORM_ABBR;

export const ALLOWED_PLATFORM_CHANNEL_IDS: Array<string> = [
  'offline_suria_klcc_voucher',
  'offline_11street_voucher',
  'offline_fave_voucher',
  'offline_candybar_voucher',
  'offline_sungei_wang_voucher',
];

export const ALLOWED_PLATFORM_CONFIG_IDS: Array<string> = [
  'fave_voucher',
  '11street_voucher',
  'klcc_voucher',
  'candybar',
  'sungei_wang_voucher',
];
